// extracted by mini-css-extract-plugin
export default {"content":"send-budget-modal_content__eOwts","actions":"send-budget-modal_actions__gyviu"};